















































import Vue from "vue";
import { formatCurrency } from "@/utility/Formatter";
import _ from "lodash";
import { mapState } from "vuex";
import { RootState } from "@/store";

// Vue Components
import MultiCurrencyCashDetailsListTable from "@/views/App/Components/MultiCurrencyCashDetailsListTable.vue";

// Model
import { TransactionFlowEnum } from "@/model/data/enums/TransactionFlowEnum";
import { CashDetail } from "@/model/data/CashDetail";

export default Vue.extend({
    components: {
        MultiCurrencyCashDetailsListTable,
    },
    props: {
        cur: { type: String, required: true },
        model: { type: String, required: true },
        flow: { type: Number, required: true },
        cashDetails: { type: Array as () => CashDetail[], required: true },
    },
    computed: {
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        cashDetailsFilteredByFlow: function () {
            return this.flow ? _.cloneDeep(this.cashDetails.filter((cd) => cd.denomination.value < 0)) : _.cloneDeep(this.cashDetails.filter((cd) => cd.denomination.value >= 0));
        },
    },
    methods: {
        formatCurrency,
    },
});
